import _ from 'lodash';
import LossCauseUtil from './LossCauseUtil';

const ExcludedBlameCodeToMap = Object.freeze({
    TPA: 'TPA',
    BTA: 'BTA'
});

const ExcludedBlameCodes_TPA_BTA = [
    ExcludedBlameCodeToMap.TPA,
    ExcludedBlameCodeToMap.BTA,
];


export default {

    getFilteredBlameCodes: (lossCaueCode, blameCodes) => {
        if (LossCauseUtil.getTPA_ExlcudeLossCause().includes(lossCaueCode)) {
            return blameCodes.filter((i) => ExcludedBlameCodeToMap.TPA !== i.code);
        }
        if (LossCauseUtil.getTPA_BTA_ExlcudeLossCause().includes(lossCaueCode)) {
            return blameCodes.filter((i) => !ExcludedBlameCodes_TPA_BTA.includes(i.code));
        }
        if (LossCauseUtil.getBTA_ExcludeLossCause().includes(lossCaueCode)) {
            return blameCodes.filter((i) => ExcludedBlameCodeToMap.BTA !== i.code);
        }
        return blameCodes;
    }
};
